/**
 * CLS-SE help-center config (labels + routes).
 */
export const HELP_LABELS = {
  sidebarTitle: 'Populära ämnen',
  popular:      'Vanligaste',
  // Reklamation hidden — uncomment label + route (and restore the App.js route) to bring it back.
  // claims:       'Reklamation',
  contact:      'Kontakta oss',
  sizeGuide:    'Storleksguide',
};

export const HELP_ROUTES = {
  faq:       '/clothing/cls-se/faq',
  // claims:    '/clothing/cls-se/claims',
  contact:   '/clothing/cls-se/contact',
  sizeGuide: '/clothing/cls-se/size-guide',
};
